export default __webpack_public_path__ + "static/media/tete11.66d7618e.png";